export const API_ROOT = '';
export const API_CONTACT_FORM = 'https://formcarry.com/s/SB0kbmrVd-7';

export const START = '_START';
export const SUCCESS = '_SUCCESS';
export const ERROR = '_ERROR';

export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const CONTACT_FORM = 'CONTACT_FORM';
export const FORM = 'FORM';

// animated logo

export const FROM = 'M90.6-5.7H86 M-6.4,85.1h5.2 M58.1,33.9l-2.7,2.7l8.5,7l2.1-2.6L63.8,39L58.1,33.9z';
export const TO = 'M98.9,1.7h-4.6 M1.9,92.5h5.2 M66.3,41.4l-2.4,2.2l8.3,7.4l2.1-2.5l-2.2-2.2L66.3,41.4z';
export const DELAY = 700;
export const ANIMATE_TIME = 150;